import $ from "jquery";
import _ from "lodash";
import { modal, modalContentSelector } from "./modal";
import { cloneableFactory } from "./cloneable";
import { positionDropDown } from "../technical/dom";
const listItemSelector = "a.dropdown-menu-text";
class DropDown {
    constructor(trigger) {
        this.trigger = trigger;
        this.trigger.find("svg").attr("aria-hidden", "true");
        //Don't remove the original menu, or cloneable.ts won't work.
        //Set to display: none to remove it from the flow.
        this.menu = this.trigger
            .next(".dropdown-menu")
            .css({ display: "none" })
            .clone()
            .css({ display: "" });
        this.menuContainer = this.trigger.closest(modalContentSelector);
        if (!_.some(this.menuContainer))
            this.menuContainer = $("body");
        this.menuContainer.append(this.menu);
        $(document).on("keydown", (e) => {
            const { key } = e;
            if (!this.isVisible())
                return;
            if (key === "ArrowUp" || key === "ArrowDown") {
                e.preventDefault();
                this.highlightNext(key);
                return;
            }
        });
        this.menu
            .on("mouseenter", listItemSelector, (e) => {
            const item = $(e.currentTarget);
            this.getListItems().removeClass("dropdown-menu-highlight");
            item.addClass("dropdown-menu-highlight");
        })
            .on("mouseleave", listItemSelector, (e) => $(e.currentTarget).removeClass("dropdown-menu-highlight"));
    }
    toggle() {
        const wasVisible = this.isVisible();
        hideAll();
        if (wasVisible)
            return;
        this.menu.addClass("dropdown-visible").css({
            minWidth: this.trigger.outerWidth() || 0,
        });
        this.trigger.attr("aria-expanded", "true");
        this.stopPositionAutoUpdate = positionDropDown({
            element: this.menu,
            relativeTo: this.trigger,
            placement: "bottom-end",
            padding: 4,
            minHeight: 200,
            maxHeight: window.innerHeight * 0.8,
        });
    }
    hide() {
        var _a;
        const wasVisible = this.isVisible();
        this.menu.removeClass("dropdown-visible");
        this.getListItems().removeClass("dropdown-menu-highlight");
        this.trigger.attr("aria-expanded", "false");
        (_a = this.stopPositionAutoUpdate) === null || _a === void 0 ? void 0 : _a.call(this);
        wasVisible && this.trigger.trigger("focus");
    }
    getMenu() {
        return this.menu;
    }
    highlightNext(key) {
        const defaultItem = key === "ArrowUp" ? "last" : "first";
        const nextItem = key === "ArrowUp" ? -1 : 1;
        const items = this.getListItems().not(".hidden");
        const itemsArray = items.toArray();
        const highlightedIndex = itemsArray.findIndex((i) => $(i).hasClass("dropdown-menu-highlight"));
        let item = $(itemsArray[highlightedIndex + nextItem]);
        if (!_.some(item))
            item = items[defaultItem]();
        this.highlight(item);
    }
    highlight(item) {
        const items = this.getListItems();
        items.removeClass("dropdown-menu-highlight");
        item.addClass("dropdown-menu-highlight").trigger("focus");
    }
    isVisible() {
        return this.menu.hasClass("dropdown-visible");
    }
    getListItems() {
        return this.menu.find("a.dropdown-menu-text");
    }
}
const initialise = (container) => {
    const triggers = $(container).find("[data-dropdown-trigger]");
    triggers.toArray().forEach((t) => {
        const trigger = $(t);
        if (!trigger.data("dropdown-model")) {
            const dropDown = new DropDown(trigger);
            trigger.data("dropdown-model", dropDown);
        }
    });
};
const hideAll = () => $("[data-dropdown-trigger]")
    .toArray()
    .forEach((t) => $(t).data("dropdown-model").hide());
export const getMenu = (trigger) => {
    const dropDown = trigger.data("dropdown-model");
    return dropDown === null || dropDown === void 0 ? void 0 : dropDown.getMenu();
};
$(document)
    .on("click", (e) => {
    const trigger = $(e.target).closest("[data-dropdown-trigger]");
    const dropDown = trigger.data("dropdown-model");
    if (dropDown) {
        dropDown.toggle();
    }
    else {
        hideAll();
    }
})
    .on("keydown", ({ key }) => {
    if (key === "Escape")
        hideAll();
});
$(() => initialise(document));
modal.on("show", (modal) => initialise(modal));
cloneableFactory.on("itemAdded", (row) => initialise(row));
